module.exports = __webpack_public_path__ + "img/bg-main-mobile.1c830a4b.jpg";